/**
 * HelpFooter — site-wide thin band above the editorial Footer with
 * contact info from 00 Global Setup.xlsx (support_email + support_phone).
 *
 * Renders nothing if both fields are blank, or on /print/* routes (those
 * pages produce print artifacts and have their own ProvenanceFooter).
 */
import { useLocation } from 'react-router-dom';
import { useSetupCampaigns } from '@state/useSetupCampaigns';

export function HelpFooter() {
  const { supportEmail, supportPhone } = useSetupCampaigns((s) => s.global);
  const location = useLocation();

  if (location.pathname.startsWith('/print/')) return null;

  const email = supportEmail?.trim();
  const phone = supportPhone?.trim();
  if (!email && !phone) return null;

  return (
    <div
      role="contentinfo"
      aria-label="Help and contact"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: '6px 14px',
        background: 'var(--paper-2, #f7f5ef)',
        borderTop: '1px solid var(--rule, rgba(0,0,0,0.08))',
        fontSize: 12,
        color: 'var(--ink-700, #333)',
        fontFamily: "'Segoe UI Variable Text', 'Segoe UI', Tahoma, sans-serif",
      }}
    >
      <span style={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: 11, color: 'var(--ink-500, #777)' }}>
        Need help?
      </span>
      {email && (
        <a
          href={`mailto:${email}`}
          style={{ color: 'var(--teal-2, #0d6b6e)', textDecoration: 'none' }}
        >
          {email}
        </a>
      )}
      {email && phone && <span style={{ color: 'var(--ink-300, #bbb)' }}>·</span>}
      {phone && (
        <a
          href={`tel:${phone.replace(/[^+\d]/g, '')}`}
          style={{ color: 'var(--teal-2, #0d6b6e)', textDecoration: 'none' }}
        >
          {phone}
        </a>
      )}
    </div>
  );
}
